// utils/plScenarioUtils.js

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatPercentage = (value) => {
  return `${value.toFixed(1)}%`;
};

export const hasAllZeroValues = (item) => {
  return Object.values(item.projected_amounts).every(amount => amount === 0);
};

export const groupBySubcategory = (items) => {
  const grouped = {};
  
  items.forEach(item => {
    const fqn = item.fully_qualified_name || item.account_name;
    const parts = fqn.split(':');
    const key = parts.length > 1 ? parts[0] : 'Other';
    
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(item);
  });

  return grouped;
};

export const organizeLineItems = (lineItems) => {
  const structure = {
    income: [],
    cogs: [],
    expenses: [],
    otherIncome: [],
    otherExpenses: []
  };

  lineItems.forEach(item => {
    const classification = item.classification;
    const accountType = item.account_type;

    if (classification === 'Revenue') {
      if (accountType === 'Income') {
        structure.income.push(item);
      } else if (accountType === 'Other Income') {
        structure.otherIncome.push(item);
      }
    } else if (classification === 'Expense') {
      if (accountType === 'Cost of Goods Sold') {
        structure.cogs.push(item);
      } else if (accountType === 'Other Expense') {
        structure.otherExpenses.push(item);
      } else if (accountType === 'Expense') {
        structure.expenses.push(item);
      }
    }
  });

  return structure;
};

export const generateQuarters = (months) => {
  const q1Months = months.filter(m => [1,2,3].includes(m.month_num));
  const q2Months = months.filter(m => [4,5,6].includes(m.month_num));
  const q3Months = months.filter(m => [7,8,9].includes(m.month_num));
  const q4Months = months.filter(m => [10,11,12].includes(m.month_num));
  
  return [
    { 
      quarter: 'Q1', 
      months: q1Months,
      is_actual: q1Months.every(m => m.is_actual),
      is_partial: q1Months.some(m => m.is_actual) && !q1Months.every(m => m.is_actual)
    },
    { 
      quarter: 'Q2', 
      months: q2Months,
      is_actual: q2Months.every(m => m.is_actual),
      is_partial: q2Months.some(m => m.is_actual) && !q2Months.every(m => m.is_actual)
    },
    { 
      quarter: 'Q3', 
      months: q3Months,
      is_actual: q3Months.every(m => m.is_actual),
      is_partial: q3Months.some(m => m.is_actual) && !q3Months.every(m => m.is_actual)
    },
    { 
      quarter: 'Q4', 
      months: q4Months,
      is_actual: q4Months.every(m => m.is_actual),
      is_partial: q4Months.some(m => m.is_actual) && !q4Months.every(m => m.is_actual)
    },
  ];
};